// Current software version. Increment this on each release.
export const APP_VERSION = '1.0.8';
